export default function Contact() {
  
    return (
      <div className='Contact'>
        <p><b>PLANEX RADIO d.o.o.</b></p>
        <p><b>Varaždinska 49A, Cargovec, 42205 Vidovec</b></p>
        <p><b>OIB:</b> 50184816348</p>
        <p><b>IBAN:</b> HR3023600001101737858    Zagrebačka banka d.d.</p>

        <h3>DIREKTOR</h3>
        <p>Telefon: 042 209 004</p>
        <p>Mail: planex@radiomegaton.hr</p>

        <h3>UREDNIK</h3>
        <p>Telefon: 042 209 006</p>
        <p>Mail: urednik@radiomegaton.hr</p>

        <h3>GLAZBENI UREDNIK</h3>
        <p>Telefon: 042 209 007</p>
        <p>Mail: miro@radiomegaton.hr</p>

        <h3>MARKETING</h3>
        <p>Telefon: 042 209 004</p>
        <p>Mail: marketing@radiomegaton.hr</p>

        <h3>ETER - JAVLJANJE UŽIVO</h3>
        <p>Telefon: 042 209 001 / 042 209 002</p>

        <h3>SMS PORUKE</h3>
        <p>Mob: 091 209 0010</p>

        <div>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52450.82704342358!2d16.235635054520188!3d46.29778070520097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476f557b87816171%3A0x93f4d4089f57145a!2sRadio%20Megaton!5e0!3m2!1sen!2shr!4v1617562278874!5m2!1sen!2shr" width="600" height="450"  allowFullScreen="" loading="lazy" title="gmapsmegaton"></iframe>
        </div>
      </div>
    );
  }